import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-offer',
    templateUrl: './offer.component.html',
    styles: [],
})
export class OfferComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
